import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import textNodesAdapter from './text_nodes.adapter';
import utils from './text_nodes.utils';

import type {
  TextNodeAutofitAdjustmentPayload,
  TextNodeChangePayload,
  TextNodeEntity,
  TextNodeSliceIntialState,
} from './text_nodes.types';

const initialState: TextNodeSliceIntialState = {
  activeNodeUid: null,
};

const textNodesSlice = createSlice({
  name: 'textNodes',
  initialState: textNodesAdapter.getInitialState(initialState),
  reducers: {
    changeActiveTextNode(state, { payload }: PayloadAction<Partial<TextNodeEntity>>) {
      if (!state.activeNodeUid) return state;

      return textNodesAdapter.updateOne(state, {
        id: state.activeNodeUid,
        changes: payload,
      });
    },
    setActiveTextNodeUid(state, { payload }: PayloadAction<string>) {
      return {
        ...state,
        activeNodeUid: payload,
      };
    },
    initializeTextNodes(state, { payload }: PayloadAction<TextNodeChangePayload[]>) {
      const removals = state.ids.filter((id) => !payload.find((item) => item.id === id));

      let update = textNodesAdapter.removeMany(state, removals);

      const changes = payload.map((change) => {
        const initialData = state.entities[change.id] || utils.textNodeDefaults;
        return {
          id: change.id,
          ...initialData,
        };
      });

      return textNodesAdapter.upsertMany(update, changes);
    },
    addCartProductTextNodes(state, { payload }: PayloadAction<TextNodeEntity[]>) {
      const fresh = textNodesAdapter.getInitialState(initialState);
      return textNodesAdapter.addMany(fresh, payload);
    },
    autofitTextAdjustment(state, { payload }: PayloadAction<TextNodeAutofitAdjustmentPayload>) {
      const adjusting = state.entities[payload.id];
      if (!adjusting) return state;

      // TODO: Add font min/max values here
      const fontNum = Math.floor(parseInt(adjusting.fontSize) * payload.adjustment);

      return textNodesAdapter.updateOne(state, {
        id: payload.id,
        changes: {
          fontSize: fontNum.toString(),
        },
      });
    },
  },
});

export default textNodesSlice;
